import $ from 'jquery';

if($("body.member#session").length){
	const formEl = document.querySelector("#form");
	const currentPageEl = document.querySelector("#currentPage");
	const maxPage = document.querySelector("#maxPage");
	const progressEl = document.querySelector("#progress progress");
	const pages = document.querySelectorAll(".page");
	const prevPageBtnEl = document.querySelector("#prevPageBtn")
	const nextPageBtnEl = document.querySelector("#nextPageBtn")
	const historyPageBtnEl = document.querySelector("#historyPageBtn")
	const saveBtnEl = document.querySelector("#saveBtn")
	const nextPageBtnTextEl = document.querySelector("#nextPageBtnText");
	const prevPageBtnTextEl = document.querySelector("#prevPageBtnText");
	const historyListSelectEl = document.querySelector("#historyList select");
	const pathname = window.location.pathname.split("/");
	const sessionId = pathname[pathname.length - 1]
	const memberId = document.querySelector("body").dataset.memberId;
	const storageKey = `session_data_${sessionId}_${memberId}`;
	let nowPage = 1;

	function save(){
		if(formEl.classList.contains('history')){
			return;
		}

		const elements = form.elements;
		const formData = {};

		for (let el of elements) {
			if (!el.name) continue;

			// name属性から [] を除去
			const name = el.name.replace(/\[\]$/, '');

			if(name == 'csrf_token'){
				continue;
			}else if (el.type === 'checkbox') {
				if (!formData[name]) formData[name] = [];
				if (el.checked) formData[name].push(el.value);
			} else if (el.type === 'radio') {
				if (el.checked) {
					formData[name] = el.value;
				}
			} else {
				formData[name] = el.value;
			}
		}
		formData['nowPage'] = nowPage;
		formData['version'] = form.dataset.version;

		localStorage.setItem(storageKey, JSON.stringify(formData));
	};

	function load(){
		if(formEl.classList.contains('history')){
			return;
		}

		const savedData = localStorage.getItem(storageKey);
		if (!savedData) {
			return;
		}

		const formData = JSON.parse(savedData);

		if(formData.version != form.dataset.version){
			return;
		}

		const elements = form.elements;

		for (let el of elements) {
			if (!el.name) continue;

			const name = el.name.replace(/\[\]$/, '');

			if (!(name in formData)) continue;

			if (el.type === 'checkbox') {
				el.checked = formData[name].includes(el.value);
			} else if (el.type === 'radio') {
				el.checked = formData[name] === el.value;
			} else {
				el.value = formData[name];
			}
		}
		if(formData['nowPage']){
			nowPage = formData['nowPage'];
		}
	};

	function complete(){
		if(formEl.classList.contains('history')){
			window.location = "../list";
			return false;
		}
		if(validate() && form.checkValidity()){
			localStorage.removeItem(storageKey);
			formEl.submit();
			return true;
		}
		return false;
	}

	function validate() {
		if(formEl.classList.contains('history')){
			return true;
		}

		const elements = form.elements;

		for (let el of elements) {
			if (!el.name) continue;
			if (el.offsetParent !== null) {
				//チェックボックス数制限
				if (el.type === 'checkbox') {
					let count = 0;
					const checkboxes = document.querySelectorAll(`input[name="${el.name}"]`);
					checkboxes.forEach(cb => {
						if (cb.name == el.name && cb.checked) {
							count++;
						}
					});

					const maxChecked = el.dataset.limit;
					if (maxChecked && count > maxChecked) {
						el.setCustomValidity(`最大${maxChecked}つまで選べます`);
					}else if (count == 0){
						el.setCustomValidity('1つ以上選択してください');
					}else{
						el.setCustomValidity('');
					}
				}

				const isValid = el.reportValidity();
				if (!isValid) {
					el.scrollIntoView();
					return false;
				}
			}
		};

		return true;
	}

	load();

	if(progressEl){
		progressEl.max = pages.length;
		maxPage.textContent = pages.length;
	}
	function pageChange(page, isValidate = false){
		if(isValidate && !validate()){
			return;
		}
		nowPage = page;
		pages.forEach(function(page, index) {
			if(index === nowPage - 1){
				page.style.display = "block";
			} else {
				page.style.display = "none";
			}
			window.scrollTo({ top: 0 });
		});
		document.querySelectorAll('.page iframe').forEach(function(vimeo) {
			if(vimeo.src.replace("https://", "").replace("http://", "").startsWith("player.vimeo.com")){
				const player = new Vimeo.Player(vimeo);
				player.pause();
			}
		});

		if(progressEl){
			currentPageEl.textContent = nowPage;
			progressEl.value = nowPage;
			if(prevPageBtnEl){
				if(nowPage == 1){
					if(formEl.classList.contains('history') && sessionId.startsWith("h-")){
						prevPageBtnTextEl.textContent = "マイページに戻る";
					}
					if(progressEl.max == 1){
						prevPageBtnEl.remove();
					}
				}else{
					prevPageBtnTextEl.textContent = "戻る";
				}
			}
			if(nextPageBtnEl){
				if(nowPage == progressEl.max){
					if(formEl.classList.contains('history')){
						nextPageBtnTextEl.textContent = "一覧へ";
						if(sessionId.startsWith("h-")){
							nextPageBtnTextEl.textContent = "マイページに戻る";
						}
					}else{
						nextPageBtnTextEl.textContent = "完了";
						if(sessionId.startsWith("h-")){
							if(sessionId.startsWith("h-05")){
								nextPageBtnTextEl.textContent = "閉じる";
							}else{
								nextPageBtnTextEl.textContent = "回答を保存して閉じる";
							}
						}
					}
				}else{
					nextPageBtnTextEl.textContent = "次へ";
				}
			}
		}

		if(sessionId == "s-03"){
			if(nowPage == 7){
				document.querySelector('textarea[name="q4"]').value = document.querySelector('textarea[name="q1"]').value;
				const q2 = [];
				document.querySelectorAll('input[name="q2[]"]').forEach((el)=>{
					if(el.checked){
						q2.push(el.value);
					}
				});
				q2.push(document.querySelector('textarea[name="q2_other"]').value);
				document.querySelector('textarea[name="q5"]').value = q2.join(' ');
				document.querySelector('textarea[name="q6"]').value = document.querySelector('textarea[name="q3"]').value;
			}
		}

		save();
	}
	pageChange(nowPage);

	prevPageBtnEl?.addEventListener("click", function() {
		if(nowPage == 1){
			if(formEl.classList.contains('history') && sessionId.startsWith("h-")){
				window.location = "../mypage";
			}else{
				save();
				window.location = "../list";
			}
		}else{
			pageChange(Math.max(1, nowPage - 1), true);
		}
	});
	nextPageBtnEl?.addEventListener("click", function() {
		if(nowPage == progressEl.max){
			if(formEl.classList.contains('history') && sessionId.startsWith("h-")){
				window.location = "../mypage";
			}else{
				nextPageBtnEl.disabled = true;
				if(!complete()){
					nextPageBtnEl.disabled = false;
				}
			}
		}else{
			pageChange(Math.min(progressEl.max, nowPage + 1), true);
		}
	});
	saveBtnEl?.addEventListener("click", function() {
		saveBtnEl.disabled = true;
		if(!complete()){
			saveBtnEl.disabled = false;
		}
	});

	historyListSelectEl?.addEventListener("change", function() {
		formEl.submit();
	});

	historyPageBtnEl?.addEventListener("click", function(e) {
		if (!window.confirm("回答途中の内容は消えてしまいますがよろしかったですか？")) {
			e.preventDefault();
		}
	});

	document.querySelectorAll('.slider').forEach(function(slider) {
		const input = slider.querySelector('input');
		const sliderValue = slider.querySelector('p span');
		function update(){
			const ratio = (input.value - input.min) / (input.max - input.min) * 100;
			input.style.background = `linear-gradient(90deg, var(--activeColor) ${ratio}%, var(--inactiveColor) ${ratio}%)`;
			sliderValue.textContent = input.value;
			sliderValue.style.left = `${ratio}%`;
		}
		let timeout = null;
		input.addEventListener("input", function() {
			update();
			if(timeout){
				clearTimeout(timeout);
			}
			input.classList.add('active');
			timeout = setTimeout(() => { input.classList.remove('active') }, 2000);
		});
		update();
	});

	window.addEventListener('pageshow', function(event) {
		if (event.persisted) {
			location.reload(true);
		}
	});
}